module.exports = __webpack_public_path__ + "img/40_38_029_750.5b7f90ac.jpg";